import { useEffect, useState } from 'react';
import { toLocalISOString, formatearFechaLocal, normalizarFechaISO } from '../../../utils/horaLocal';

export function useFechaDelDia() {
  const [fechaDelDia, setFechaDelDia] = useState(() => {
    const fechaGuardada = localStorage.getItem('fechaDelDia_kardex');
    return fechaGuardada || toLocalISOString();
  });

  useEffect(() => {
    localStorage.setItem('fechaDelDia_kardex', fechaDelDia);
  }, [fechaDelDia]);

  const cambiarFechaDelDia = (nuevaFecha) => {
    setFechaDelDia(nuevaFecha);
  };

  const obtenerFechaDelDiaFormato = () => {
    return formatearFechaLocal(normalizarFechaISO(fechaDelDia));
  };

  return {
    fechaDelDia,
    cambiarFechaDelDia,
    obtenerFechaDelDiaFormato,
  };
}
